import styled from "styled-components";

export const NotFoundPageContentLayout = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-size: 1.5rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.placeholderTxt};
  }
`;
